import { PublicProfile } from "@dimensional-engineering/dimensional-models";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import styles from "./ArchetypeTraitsPageLeftBar.module.css";

import LargeArchetype from "@/components/traits/arcehtype/Archetypes/LargeArchetype/LargeArchetype";
import TraitsAndDimensionsDownloadButton from "@/components/traits/shared/TraitsDownloadButton/TraitsAndDimensionsDownloadButton";
import { ExtendedArchetype } from "@/models/sharedModels";
import { RootState } from "@/redux/store";
import TraitScoreBar from "../../shared/TraitScoreBar/TraitScoreBar";
import useConnectionStatus from "@/helpers/useConnectionStatus";
import { traitPermissionStatus } from "../../utils";
import TraitAccessDeniedBar from "../../shared/TraitAccessDeniedBar/TraitAccessDeniedBar";
import TraitDescription from "../../shared/TraitScoreTable/TraitDescription";
import AverageUserScore from "@/components/shared/AverageUserScore/AverageUserScore";
import { archetypeMapper } from "@/assets/traitInfo/dimensionData";

type LeftBarProps = {
  archetype: ExtendedArchetype;
  auth?: boolean;
  nonOwnProfile?: boolean;
  friendScore?: number | null | undefined;
  publicProfile?: PublicProfile | null;
};

export default function ArchetypeTraitsPageLeftBar(props: LeftBarProps) {
  const [score, setScore] = useState<number | null>();
  const userState = useSelector((state: RootState) => state.user);
  const friendStatus = useConnectionStatus(props.publicProfile?.ownerUUID);

  useEffect(() => {
    if (props.auth) {
      if (props.nonOwnProfile) {
        setScore(props.friendScore);
      } else {
        userState.archetypesDiscovered?.forEach((arch) => {
          if (arch.archetypeSlug === props.archetype.slug) {
            setScore(arch.archetypeScore);
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.auth, props.friendScore, props.nonOwnProfile]);

  if (props.auth) {
    if (!props.nonOwnProfile) {
      // own profile
      return (
        <div className={styles.leftBar}>
          <LargeArchetype archetype={props.archetype} />
          <div className={styles.defDiv}>
            <div className={styles.defTitleDiv}>
              <h3>Quick definition</h3>
            </div>
            <p>{props.archetype.shortDescription}</p>
          </div>
          <div className={styles.scoreDiv}>
            <TraitScoreBar score={score != null ? score * 100 : null} />
          </div>
          <TraitDescription type="Archetype" />
        </div>
      );
    } else {
      const status = traitPermissionStatus(
        friendStatus,
        props.archetype.connectionAvailabilities
      );
      ///connected profile
      return (
        <div className={styles.leftBar}>
          <LargeArchetype archetype={props.archetype} />
          <div className={styles.defDiv}>
            <div className={styles.defTitleDiv}>
              <h3>Quick definition</h3>
            </div>
            <p>{props.archetype.shortDescription}</p>
          </div>
          <div className={styles.scoreDiv}>
            {status === null ? (
              <TraitScoreBar
                friendPublicProfile={props.publicProfile}
                nonOwner
                score={score != null ? score * 100 : null}
              />
            ) : (
              <TraitAccessDeniedBar
                publicProfile={props.publicProfile}
                connectionTypeNeeded={status}
              />
            )}
          </div>
          <TraitDescription type="Archetype" />
        </div>
      );
    }
  } else {
    //seo pages
    return (
      <div className={styles.leftBar}>
        <LargeArchetype archetype={props.archetype} />
        <div className={styles.defDiv}>
          <div className={styles.defTitleDiv}>
            <h3>Quick definition</h3>
          </div>
          <p>{props.archetype.shortDescription}</p>
        </div>
        {props.archetype.traitContent.averagePercentScore && (
          <div className={styles.buttonDiv}>
            <AverageUserScore
              score={props.archetype.traitContent.averagePercentScore}
            />
          </div>
        )}
        <div className={styles.buttonDiv}>
          <TraitsAndDimensionsDownloadButton message="Find your score on over 100 traits on Dimensional." />
        </div>
      </div>
    );
  }
}
